export class SendCampaignOperationsEntity {
    campaign;
    mailingLists;
    recipients;
    sentByUser;

    constructor(campaign, mailingLists, recipients, sentByUser) {
        this.campaign = campaign;
        this.mailingLists = mailingLists;
        this.recipients = recipients;
        this.sentByUser = sentByUser;
    }
}